function importAll(r) {
    let images = {};
    r.keys().forEach((item) => {
      const key = item.replace('./', '').split('.')[0];
      images[key] = r(item);
    });
    return images;
  }
  
  const allImages = importAll(require.context('./images', false, /\.(png|jpe?g|svg)$/));
  
  export default allImages;
